export default {
  patients: {
    label: '标签',
    viewPatients: '查看患者',
    viewPatient: '查看患者',
    editPatient: '改变病人',
    newPatient: '新病人',
  },
}
